import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

export const fetchSiteContent = async () => {
  const { data } = await api.get('/site/content');
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await api.post('/contact', payload);
  return data;
};

export const submitMembershipInquiry = async (payload) => {
  const { data } = await api.post('/membership-inquiry', payload);
  return data;
};

export const submitMembershipEnrollment = async (payload) => {
  const { data } = await api.post('/membership/enroll', payload);
  return data;
};
